import {BasicSelect,MultiSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import CONSTANT from './../../../../shared/constants/constant';
import Util from './../../../../shared/util/util';
import Treeselect from '@riophae/vue-treeselect';
import FTCservices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service'
import XLSX from 'xlsx';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
const moment = require('moment');


export default {
  name: 'createFTCRADShipment',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    FTCservices,
    Multiselect
  },
  data: function() {
    return {
  isLoading:false,
  banklist:[
    {id:'BOI',label:'BOI'},
    {id:'ICICI',label:'ICICI'},
    {id:'Axis',label:'Axis'},
    {id:'BOM',label:'BOM'},
  ],
  branchlist:[
    // {id:'Pune',label:'Pune'},
    // {id:'Mumbai',label:'Mumbai'},
    // {id:'Nashik',label:'Nashik'},
    // {id:'Nagpur',label:'Nagpur'},
  ],
  Accountlist:[
    // {id:26566,label:'26566'},
    // {id:25645,label:'25645'},
    // {id:26884,label:'26884'},
    // {id:98522,label:'98522'},
    // {id:25844,label:'25844'},
    // {id:25967,label:'25967'},
  ],
  bankName:null,
  accountNumber:null,
  branchName:null,
  cashDepositAmount:"",
  cashDepositDate:"",
  cashDepositBy:"",
  cashDepositSlip:"",
  userName:"",
  defaultHubID:'',
  depositImage:'',
  disabled:false,
  selectedBankName:'',
  bankNameErr : '',
  branchNameErr : '',
  accountNumberErr : '',
  cashDepositAmountErr : '',
  cashDepositDateErr : '',
  cashDepositByErr : '',
  cashDepositSlipErr : '',
  depositImageErr : '',
  filename:'',
  dt:'',
  bankmasterlist: [],
  lblCashCollectible: 0,
  arrWayBillNumbers: [],
  mdlWayBillNumber: null,
  lblWayBillErr: ''
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.defaultHubID = userdetail.hubID[0];
    this.dt = moment().tz('Asia/Kolkata').format("YYYY-MM-DD")
    this.getbanklisitng();
    this.fetchWayBillNumbers()
  },
  methods: {
    async saveFTCDeposit(){
      try {
        let wayBillNumbers = this.mdlWayBillNumber.map(val => val.waybillNumber) 
        const keyToRemove = "id"; // Replace with the key you want to remove
        const modifiedData = this.mdlWayBillNumber.map(item => {
          // Use object destructuring to create a copy of the object
          const modifiedItem = Object.assign({}, item);
          // Use the delete operator to remove the specified key
          delete modifiedItem[keyToRemove];
          // Return the modified item
          return modifiedItem;
        });
        if(this.validator()) return;
        this.isLoading = true
        let input = {
          "hubid":this.defaultHubID,
          "lastmodifiedby":this.userName,
          "bankname":this.selectedBankName,
          "branchname": this.branchName == "None" ? null:this.branchName,
          "accountnumber": this.accountNumber == "None" ? null:this.accountNumber,
          "depositamount": this.cashDepositAmount,
          "depositdate": this.cashDepositDate,
          "depositby": this.cashDepositBy,
          "depositslipno":this.cashDepositSlip,
          "depositslipimage": this.depositImage,
          "awb":modifiedData
        }
        let result = await FTCservices.saveFTCDeposit(input)
        this.isLoading = false
        if(result.data.code==200){
          let DepositId = result.data.data.depositid
          this.$alertify.success("Cash Deposit "+DepositId+" has been saved and sent to finance for verification");
          this.reset()
          this.$emit('goBackToParent');
        }
        else{
          this.$alert(result.data.message, "", "error");
        }
      }
    catch(err){
        this.isLoading = false
        console.log(err)
      }
    },
    validateUpload(e){
      if(!this.cashDepositSlip){
        e.preventDefault();
        this.$alert("", "Enter Cash Deposit Slip Number", "error");
      }
    },
    async getbanklisitng(){
      try {
        this.isLoading = true;
        let result = await FTCservices.getBankListing({});
        if(result.data.code == 200){
          this.bankmasterlist = result.data.data
          this.banklist = [];
          this.bankmasterlist.forEach(el=>{
            this.banklist.push({
              id : el.BankMasterId,
              label : el.BankName
            })
          })
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    selectBank(el){
      let bankRecord = this.bankmasterlist.find(item=>item.BankMasterId == el.id);
      this.selectedBankName = bankRecord.BankName; 
      this.accountNumber = bankRecord.AccountNo?bankRecord.AccountNo:"None";
      this.branchName = bankRecord.BranchName?bankRecord.BranchName:"None";
    },
    validator() {
      let err = 0
      this.cashDepositAmount = Number(this.cashDepositAmount)
      if (!this.mdlWayBillNumber) {
        this.$alert(`Please select atleast one way bill .`, "Waybill Number is mandatory", "error");
        this.lblWayBillErr = "Please Select WayBill Number"
      } 
      if (!this.bankName || !this.selectedBankName) {
        this.bankNameErr = "Select bank Name"
        err = 1;
      } else {
        this.th = '';
      }
      // if (!this.branchName) {
      //   this.branchNameErr = "Enter branch Name"

      //   err = 1;
      // } else {
      //   this.branchNameErr = '';
      // }
      // if (!this.accountNumber) {
      //   this.accountNumberErr = "Enter account Number"
      //   err = 1;
      // } else {
      //   this.accountNumberErr = '';
      // }
      if (!this.cashDepositAmount) {
        this.cashDepositAmountErr = "Enter cash Deposit Amount"
        err = 1;
      }
      else if (this.cashDepositAmount < 0 || this.cashDepositAmount == 0) {
        this.cashDepositAmountErr = "Cash Deposit Amount should be greater than Zero"
        err = 1;
      }else if(!this.cashDepositAmount.toString().match(/^[0-9]*$/)){
        this.cashDepositAmountErr = "Please Enter valid Cash Deposit Amount"
        err = 1;
      } else if (this.lblCashCollectible != this.cashDepositAmount) {
        this.$alert(`FTC Cash Collectible does not match, please provide the correct Deposit details.`,"Save Deposit","error");
        this.cashDepositAmountErr = "FTC Cash Collectible does not match, please provide the correct Deposit details"
        err = 1;
      }
      else {
        this.cashDepositAmountErr = '';
      }
      if (!this.cashDepositDate) {
        this.cashDepositDateErr = "Enter cash Deposit Date"
        err = 1;
      } else {
        this.cashDepositDateErr = '';
      }
      if (!this.cashDepositBy) {
        this.cashDepositByErr = "Enter cash Deposit By"
        err = 1;
      }
      else if (!this.cashDepositBy.match(/^$|^\S+.*/)) {
        this.cashDepositByErr = "Please Enter Valid Cash Deposit By"
      }
      else {
        this.cashDepositByErr = '';
      }
      if (!this.cashDepositSlip) {
        this.cashDepositSlipErr = "Enter Cash Deposit Slip Number"
        err = 1;
      }       
      else if (!this.cashDepositSlip.match(/^$|^\S+.*/)) {
        this.cashDepositSlipErr = "Please Enter Valid Cash Deposit Slip Number"
      }
       else {
        this.cashDepositSlipErr = '';
      }
      if (!this.depositImage) {
        this.depositImageErr = "Upload Deposit Slip Image"
        err = 1;
      } else {
        this.depositImageErr = '';
      }
      return err;
    },
    openImage(image) {
      if(image!=''){
      this.disabled=false
      let modal = document.getElementById('myModalImg' + image);
      var img = document.getElementById('imgid' + image);
      var modalImg = document.getElementById("img" + image);
      var captionText = document.getElementById("captionImg" + image);
      modal.style.display = "block";
      modalImg.src = image;
        this.isLoading = true;
        modalImg.style.display = 'none';
        modalImg.onload = () => {
          this.isLoading = false;
        modalImg.style.display = 'block ';
        }
        modalImg.onerror = () => {
          this.isLoading = false;
          console.log("unable to load image");
        }
      }
      else{
        this.disabled = true
      }
    },
    closemodal(id) {
      let modal = document.getElementById(id);
      modal.style.display = "none";
    },
    reset(){
      this.disabled=false;
      this.bankName = null;
      this.selectedBankName = '';
      this.branchName = null;
      this.accountNumber = null;
      this.cashDepositAmount = '';
      this.cashDepositDate = '';
      this.cashDepositBy = '';
      this.cashDepositSlip = '';
      this.depositImage = '';
      this.bankNameErr = '';
      this.branchNameErr = '';
      this.accountNumberErr = '';
      this.cashDepositAmountErr = '';
      this.cashDepositDateErr = '';
      this.cashDepositByErr = '';
      this.cashDepositSlipErr = '';
      this.depositImageErr = '';
      this.filename = ''
    },
    expandAll(){
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    async handleFileUpload(event){
      this.isLoading = true
      let uploadFile = event.target.files[0];
      if(uploadFile != undefined){
        this.filename = uploadFile.name
      if(uploadFile.size > 5242880){
        this.isLoading=false
        return this.$alert(`Please Upload Document Less Than 5MB.`,"Freight to Collect","error");
      }
      if (uploadFile.type == "image/jpeg" || uploadFile.type == "image/jpg" ||uploadFile.type == "image/png" || uploadFile.type == ""){
        let formData = new FormData();
        formData.append("file", uploadFile);
        formData.append("depositslipno", this.cashDepositSlip);
        let result = await FTCservices.uploadDepositImage(formData)
        if(result.data.code==200){
          this.depositImage = result.data.data[0].Location
          this.isLoading= false,
          this.$alertify.success("Images uploaded successfully !");
        }
        else {
          event.target.value = '';
          this.isLoading=false
          this.$alert("Document Upload Failed.","Freight to Collect","error");
        }
      }
      else {
        event.target.value = '';
        this.isLoading=false
        this.$alert("Please upload only Allowed file format","Freight to Collect","error");
       return true;
      }
    }
    else{
      this.isLoading=false
    }
    },
    collapseAll(){
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid){
      this.expanded = false;
      for (var key in this.accordianTab) {
        if(tabid != key){
          this.accordianTab[key] = false;
        }
      }
    },
    clickConfirmAction(){
      this.showFTCAmount =true;
    },
    clickPrintCashMemo(){
      this.showPrintCashMemo =true;
    },
    showCreateFTCShipment(){
      this.$emit("goBackToParent")
    },
    /**
     * @description : This function will fetched the waybill number 
     * @returns: List of Waybill Number list in array od JSON
     */
     async fetchWayBillNumbers(){
       try {        
        this.isLoading = true;
        let wayBillDetails = await FTCservices.fetchWayBillNumbers({hubid:this.defaultHubID});
        if (wayBillDetails.data.code == 200) {
          if(wayBillDetails.data.data && wayBillDetails.data.data.length > 0)
            this.arrWayBillNumbers = wayBillDetails.data.data.map(val => {
              return { id: val.awb, awb: val.awb, ftcamount:val.ftcamount, clientid:val.clientid, clientbusinessaccountid:val.clientbusinessaccountid, srid:val.srid, 
                deliverydatetime: moment.utc(val.deliverydatetime).format("DD-MM-YYYY HH:mm:ss").valueOf(), tan: val.tan, tdsamount: val.tdsamount , amountwogst : val.amountwogst}
            })
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    async onChangeWayBillNumber(event) {
      try {
        this.isLoading = false
        this.lblCashCollectible += event.ftcamount
      } catch (error) {
        console.log(err)
        this.isLoading = false;
      }
    },
    onSelectWayBill(selectedOption, id) {
      this.lblCashCollectible += parseFloat(selectedOption.ftcamount)
      
    },
    onRemoveWayBillNumber(removedOption, id) {
      this.lblCashCollectible -= parseFloat(removedOption.ftcamount)
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/FTCHubCashDeposit/createFTCHubCashDeposit/createFTCHubCashDeposit.component.js